import { registerNavigationConfirmation } from './navigationConfirmation';
import { useCallback, useEffect, useRef, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from '../ui/dialog';
import { Button } from '../ui/button';

/** Use the router's confirmation callback so PUSH, REPLACE and browser Back
 * retain their original semantics, with a usable in-app confirmation on touch. */
export default function DashboardRouter({ children, ...props }) {
  const [message, setMessage] = useState(null);
  const pending = useRef(null);
  const confirmNavigation = useCallback((nextMessage, callback) => {
    if (pending.current) { callback(false); return; }
    pending.current = callback;
    setMessage(nextMessage);
  }, []);
  useEffect(() => registerNavigationConfirmation(confirmNavigation), [confirmNavigation]);
  const answer = useCallback(allowed => {
    const callback = pending.current;
    pending.current = null;
    setMessage(null);
    callback?.(allowed);
  }, []);
  useEffect(() => () => {
    pending.current?.(false);
    pending.current = null;
  }, []);

  return <BrowserRouter {...props} getUserConfirmation={confirmNavigation}>
    {children}
    <Dialog open={message !== null} onOpenChange={open => { if (!open) answer(false); }}>
      <DialogContent showX={false}>
        <DialogHeader>
          <DialogTitle>Leave without saving?</DialogTitle>
          <DialogDescription>{message}</DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="cancel" size="workspace" onClick={() => answer(false)}>Keep editing</Button>
          <Button variant="destructive" size="workspace" onClick={() => answer(true)}>Leave without saving</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  </BrowserRouter>;
}
